import { render } from "./FrequencyList.vue?vue&type=template&id=4f9ff6c1&scoped=true"
import script from "./FrequencyList.vue?vue&type=script&lang=ts"
export * from "./FrequencyList.vue?vue&type=script&lang=ts"

import "./FrequencyList.vue?vue&type=style&index=0&id=4f9ff6c1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4f9ff6c1"

export default script